import { render, staticRenderFns } from "./SelectDestinationFund.vue?vue&type=template&id=12ab2fe5&scoped=true"
import script from "./SelectDestinationFund.vue?vue&type=script&lang=js"
export * from "./SelectDestinationFund.vue?vue&type=script&lang=js"
import style0 from "./SelectDestinationFund.vue?vue&type=style&index=0&id=12ab2fe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab2fe5",
  null
  
)

export default component.exports